import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    DailyJobLog,
    DailyJobLogDetail,
    DailyJobSummary,
} from "../typeDefs/diagnostics";

export interface DiagnosticsState {
    summary: DailyJobSummary[];
    summaryLoading: boolean;
    logs: DailyJobLog[];
    logsLoading: boolean;
    details: DailyJobLogDetail[];
    detailsLoading: boolean;
}

const initialState: DiagnosticsState = {
    summary: [],
    summaryLoading: false,
    logs: [],
    logsLoading: false,
    details: [],
    detailsLoading: false,
};

export const diagnosticsSlice = createSlice({
    name: "diagnostics",
    initialState,
    reducers: {
        setSummary: (state, action: PayloadAction<DailyJobSummary[]>) => {
            state.summary = action.payload;
        },
        setSummaryLoading: (state, action: PayloadAction<boolean>) => {
            state.summaryLoading = action.payload;
        },
        setLogs: (state, action: PayloadAction<DailyJobLog[]>) => {
            state.logs = action.payload;
        },
        setLogsLoading: (state, action: PayloadAction<boolean>) => {
            state.logsLoading = action.payload;
        },
        setDetails: (state, action: PayloadAction<DailyJobLogDetail[]>) => {
            state.details = action.payload;
        },
        setDetailsLoading: (state, action: PayloadAction<boolean>) => {
            state.detailsLoading = action.payload;
        },
    },
});

export const {
    setSummary,
    setSummaryLoading,
    setLogs,
    setLogsLoading,
    setDetails,
    setDetailsLoading,
} = diagnosticsSlice.actions;

export default diagnosticsSlice.reducer;
